import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./token.slice.ts";
import colorReducer from "./theme.color.slice.ts";
import userReducer from "./user.slice.ts";
import resturantReducer from "./resturant.slice.ts";
import clientsSearchDataReducer from "./clientsSearchDataSlice.ts"
import ordersSearchDataReducer from './ordersSearchDataSlice';
import updatesReducer from './whatsNewSlice';
import appReducer from './publishMenuSlice.ts';
import branchReducer from "./BranchSlice";
import cartReducer from './cart.slice'
import storedAppsReducer from './apps.slice'
import renderProtectionRoute from "./RenderProtectionRoute.slice.ts";
import cashierOrdersSearchDataReducer from "./cashierOrdersSearchDataSlice";
import searchReducer from "./searchSlice.ts";
import ordersReducer from "./ordersSlice.ts";
import warningReducer from "./warningSlice.ts";
import orderProgressReducer from "./orderProgressUpdate.ts";
import tableCartReducer from "./tableCartSlice.ts";
import pageReducer from "./pageSlice.ts";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    color: colorReducer,
    user: userReducer,
    resturant: resturantReducer,
    clientsSearchData: clientsSearchDataReducer,
    orderSearchData: ordersSearchDataReducer,
    updates: updatesReducer,
    status: appReducer,
    branch: branchReducer,
    cart: cartReducer,
    apps: storedAppsReducer,
    renderProtectionRoute: renderProtectionRoute,
    cashierOrdersSearchData: cashierOrdersSearchDataReducer,
    search: searchReducer,
    orders: ordersReducer,
    warning: warningReducer,
    orderProgress: orderProgressReducer,
    tableCart: tableCartReducer,
    page: pageReducer
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;